import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { MIDDLE_MARGIN } from '../../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formWrap: {
      width: '100%',
    },
    form: {
      display: 'flex',
      justifyContent: 'space-between',
      [theme.breakpoints.down('sm')]: {
        display: 'block',
      },
    },
    formField: {
      width: '100%',
    },
    btn: {
      marginTop: MIDDLE_MARGIN,
      width: 150,
      [theme.breakpoints.down('xs')]: {
        width: '100%',
      },
    },
  }),
);

export default useStyles;
